/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Spaces_UnknownInputs */



/**
* | output |
* | --- |
* | "Unavailable space" |
*
* @param {Agent_Builder_Spaces_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_spaces_unknown = /** @type {((inputs?: Agent_Builder_Spaces_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Spaces_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht verfügbarer Bereich")
	return /** @type {LocalizedString} */ ("Unavailable space")
});